import styled from 'styled-components';
import { device } from '../../../../ui-components/breakpoints';
import { StyledAnchor } from '../../../../ui-components/PlayButton/PlayButton.styles';

export const ShowMoreButton = styled(StyledAnchor)`
    margin-top: 20px;
    width: 100%;

    @media ${device.GteSmall} {
        width: auto;
        align-self: flex-start;

        margin-top: 10px;
        margin-bottom: 10px;
    }
`;
